<template>
	<div class="content">
		<!--<div class="header-box"> 2023年职业院校数字化转型典型案例评价表 </div>-->
		<!--<div class="bg-box">-->
		<!--<div class="line"></div>-->
		<div class="content-box  flex flex-col">
			<div class="contentsj">
				<div class="headerbt">
					{{ items.zpname }}
					<div class="back" @click="goback">
						<img style="width: 30px; height: 30px; cursor: pointer" src="@/assets/images/img59.png" alt=""
							title="返回" />
					</div>
				</div>

				<div v-for="(item, index) in treeFile">
					<div v-if="index == '0'">
						<h4 style="margin-bottom:10px;"><img class="img-box-2" src="@/assets/images/img24.png"
								alt="" />{{ item.title }}</h4>
						<div class="flieList">
							<span class="listitem" @click="gohrefs(items.filePath, item.title, item.previewPath)"
								v-for="(items, index1) in item.children">
								{{ getFileName(items.filePath) }}
							</span>
						</div>
						<div class="pdf-wrap"
							v-if="(previewType.toLowerCase() === 'pdf' || previewType === 'doc' || previewType === 'docx') && defaultGraph === false">
							<iframe ref="iframe" width="120%" :src="previewUrl" name="123" scrolling-y="auto"
								frameborder="0" style="width: 100%; height: 100%; background: #fff"></iframe>
						</div>
						<div class="img-preview-box" v-if="(
							(previewType === 'jpg' ||
								previewType === 'png' ||
								previewType === 'jpeg' ||
								previewType === 'bmp') && defaultGraph === false)">
							<img class="img-preview" :src="previewUrl" alt="" />
						</div>

						<div class="videowrap"
							v-if="(previewType === 'mp4' || previewType === 'MP4') && defaultGraph === false">
							<video style="height: 100%; width: 100%" controls controlsList="nodownload"
								autoplay="autoplay" :src="previewUrl"></video>
						</div>
						<div class="msg-box" v-if="defaultGraph">
							<div>
								<img style="width: 465px; height: 291px" src="~@/assets/images/img53.png" alt="" />
							</div>
							<div class="tip">暂无内容</div>
						</div>
					</div>
					<div v-if="index != '0'">
						<h4> <img class="img-box-2" src="@/assets/images/img24.png" alt="" />{{ item.title }}</h4>
						<div class="flieList">
							<span class="listitem" @click="gohref(items.filePath, item.title, items.previewPath)"
								v-for="(items, index1) in item.children">
								{{ getFileName(items.filePath) }}
							</span>
						</div>
					</div>
				</div>
			</div>
			<h5 class="headerScore" v-if="izScoring">评分</h5>
			<div class="review-content">
				<!-- 评分指标：按指标逐项打分，总分自动求和 -->
				<div class="item-score-wrap" v-if="izScoring && itemList.length > 0">
					<a-table class="table" :columns="itemColumns" :data-source="itemList" :pagination="false" row-key="id"
						bordered size="middle">
						<template slot="scoreInput" slot-scope="text, record">
							<a-input-number v-model="record.itemScore" :min="0"
								:max="record.score ? Number(record.score) : 100" :precision="0" :step="1"
								:disabled="evaluationTablePreview" placeholder="打分" />
						</template>
					</a-table>
					<div class="target-score">
						总分：<span class="number">{{ totalScore }}</span> 分
					</div>
				</div>
				<!-- 未配置评分指标时保留直接打分 -->
				<div class="score-wrap" v-if="izScoring && itemList.length === 0">
					<span class="score-label">得分：</span>
					<a-input-number class="score-input" v-model="score" :min="0" :max="100" :precision="0" :step="1"
						:disabled="evaluationTablePreview" placeholder="请输入0-100的整数" />
					<span class="score-unit">分</span>
				</div>
				<div class="expertReviews" v-if="izReview">
					<div class="expertReviews-title">专家评语</div>
					<a-textarea class="remark-input" v-model="reviewData.remark" placeholder="请输入评语~" :maxLength="500"
						:auto-size="{ minRows: 4, maxRows: 6 }" :disabled="evaluationTablePreview" />
				</div>
				<div class="submit" @click="submit" v-if="!evaluationTablePreview && (izReview || izScoring)">提交</div>
			</div>
		</div>
		<!--<div class="line"></div>-->
		<!--</div>-->
		<!--<div>
			<foot :FootType="2"></foot>
		</div>-->
		<div class="preview-pop-box" v-if="isshow">
			<div :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
				<sjshow :previewType="fileType" :title="title" :previewUrl="fileUrl" @goNewPage="goNewPage"
					@closePreview="closePreview"></sjshow>

			</div>
		</div>

	</div>
</template>

<script>
import sjshow from "./sjshow";
import foot from "@/components/footer";
import { baseURL } from "@/utils/request.js";
import { getAction, postAction, expertDateView } from "@/api/index";
export default {
	components: {
		foot,
		sjshow
	},
	data() {
		return {
			zpname: '',
			id: '',
			expertUserId: '',
			isshow: false,
			evaluationTablePreview: false,
			// 专家打分（0-100）
			score: null,
			fileType: '',
			fileUrl: '',
			reviewData: {
				// 专家评语
				remark: "",
			},
			// 评审
			reviewShow: false,
			emptyPrompt: false,
			reviewEndTimestamp: '',
			treeFile: [],
			previewType: '',
			previewUrl: '',
			defaultGraph: false,
			title: '',
			fullscreen: false,
			izScoring: false,
			izReview: false,
			// 评分指标列表
			itemList: [],
			// 评分指标表格列
			itemColumns: [
				{
					title: '评价指标', key: 'indicator', width: '20%',
					customRender: (text, record) => record.oneTarget || record.twoTarget || ''
				},
				{ title: '指标内涵', dataIndex: 'content', key: 'content' },
				{ title: '分值', dataIndex: 'score', key: 'score', width: '90px', align: 'center' },
				{
					title: () => this.$createElement('span', ['得分', this.$createElement('span', {
						style: 'color: #f5222d; margin-left: 4px;'
					}, '*')]),
					key: 'itemScore', width: '150px', align: 'center',
					scopedSlots: { customRender: 'scoreInput' }
				},
			],
		}
	},
	created() {
		this.items = JSON.parse(localStorage.getItem('items'));
	},
	mounted() {
		this.items = JSON.parse(localStorage.getItem('items'));
		// console.log(this.items,"2222");
		this.id = this.items.id;
		this.expertUserId = this.$route.query.userid,
			this.getStatus();
		this.getData();
		//				this.zpname = this.$route.query.zpname,
		this.getexpertDateView();
	},
	destroyed() {
		localStorage.removeItem('items');
	},
	computed: {
		// 各评分项分值自动求和得到总分
		totalScore() {
			return this.itemList.reduce((sum, item) => {
				const v = Number(item.itemScore);
				return sum + (isNaN(v) ? 0 : v);
			}, 0);
		},
	},
	methods: {
		getStatus() {
			getAction('/lx/lxApply/getReviewAndScore', {}).then((res) => {
				if (res.code === 200) {
					// console.log(res,"333");
					this.izScoring = res.result.izScoring == 1 ? true : false;
					this.izReview = res.result.izReview == 1 ? true : false;
					if (this.izScoring || this.izReview) {
						this.getReviewTable();
					}
				} else {
					this.$message.error(res.message);
				}
			});
		},
		goNewPage(flag) {
			//    console.log(flag);
			this.fullscreen = flag;
		},
		getFileName(name) {
			let newName = name.slice(name.lastIndexOf("/") + 1);
			let firstname = newName.slice(0, newName.lastIndexOf("_"));
			let lastname = newName.slice(newName.lastIndexOf("."));
			return firstname + lastname;
		},
		getData() {
			let treeFile = [];
			if (this.items && this.items.applyType == '4') {
				treeFile = [
					{
						title: "教学视频",
						key: 1,
						children: [],
					},
					// {
					// 	title: "数字化典型案例",
					// 	key: 9,
					// 	children: [],
					// },
					{
						title: "教学设计",
						key: 2,
						children: [],
					},
					{
						title: "微课逐字稿",
						key: 3,
						children: [],
					},
					{
					title: "参赛作品推荐表",
					key: 6,
					children: [],
				},
				{
					title: "微课课件",
					key: 7,
					children: [],
				},
				{
					title: "参赛作品信息表",
					key: 8,
					children: [],
				},
				// {
				// 	title: "佐证材料",
				// 	key: 3,
				// 	children: [],
				// },
			];
			} else {
				treeFile = [
					// {
					// 	title: "数字化典型案例",
					// 	key: 1,
					// 	children: [],
					// },
					{
						title: "数字化典型案例",
						key: 9,
						children: [],
					},
					{
						title: "典型案例报送申请表",
						key: 2,
						children: [],
					},
					// {
					// 	title: "佐证材料",
					// 	key: 3,
					// 	children: [],
					// },
				];
			}


			for (let i = 0; i < treeFile.length; i++) {
				treeFile[i].hadThree = false;
				for (let j = 0; j < this.items.applyFiles.length; j++) {
					if (treeFile[i].key == this.items.applyFiles[j].fileType) {
						// this.items.applyFiles[j].proviewPath=null;
						treeFile[i].children.push(this.items.applyFiles[j]);
					}
				}
			}
			this.treeFile = treeFile;
			// console.log(this.treeFile);
			if (this.treeFile.length > 0 && this.treeFile[0].children.length > 0) {
				let filePath = this.treeFile[0].children[0].filePath;
				if (filePath != '') {
					let fileName = filePath.lastIndexOf(".");
					this.previewType = filePath.substring(
						fileName + 1,
						filePath.length
					);
					let sj = filePath.substring(0, filePath.lastIndexOf("."));
					// 仅 office 文档使用后端转换的 pdf，其余文件（视频/图片等）保持原后缀
					let officeTypes = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"];
					if (officeTypes.indexOf(this.previewType.toLowerCase()) > -1) {
						this.previewUrl = sj + ".pdf?time=" + Math.random() + "#zoom=120";
					} else {
						this.previewUrl = baseURL + filePath + "?time=" + Math.random() + "#zoom=120";
					}
					this.defaultGraph = false;
				} else {
					this.defaultGraph = true;
				}

			} else {
				this.defaultGraph = true;
			}
		},
		// 评审提交
		submit() {
			var date1 = new Date();
			var timestamp = Date.parse(date1);
			if (timestamp > this.reviewEndTimestamp) {
				this.$message.error('评审时间已经结束');
				return false;
			}
			let params = {
				applyId: this.id,
				remark: this.reviewData.remark,
			};
			if (this.izScoring && this.itemList.length > 0) {
				// 按评分指标打分：校验每项分值，提交各项得分，由后端自动求和为总分
				let itemScores = {};
				for (let i = 0; i < this.itemList.length; i++) {
					let item = this.itemList[i];
					if (item.itemScore === null || item.itemScore === '' || item.itemScore === undefined) {
						this.$message.warning('请完成所有评分项的打分');
						return false;
					}
					let max = item.score ? Number(item.score) : 100;
					if (Number(item.itemScore) < 0 || Number(item.itemScore) > max) {
						this.$message.warning('每项得分需在0分到该指标分值之间');
						return false;
					}
					itemScores[item.id] = Number(item.itemScore);
				}
				params.itemScores = itemScores;
			} else if (this.izScoring) {
				if (this.score === null || this.score === '' || this.score === undefined) {
					this.$message.warning('请输入0-100分的得分');
					return false;
				}
				if (Number(this.score) < 0 || Number(this.score) > 100) {
					this.$message.warning('得分需在0-100分之间');
					return false;
				}
				params.score = Number(this.score);
			}
			postAction("/lx/lxExpertItem/settingScore", params).then((res) => {
				if (res.code == 200) {
					this.$message.success("提交成功");
					let that = this
					setTimeout(function () {
						localStorage.removeItem('items');
						if (that.items && that.items.applyType == '4') {
							that.$router.push({ path: '/personalCenter/alApply' });
						} else {
							that.$router.push({ path: '/personalCenter/xalApply' });
						}

					}, 2000)


				} else if (res.code == 500) {
					this.$message.error(res.message);
				}
			});
		},
		goback() {
			this.$router.push({ name: 'alApply' }); localStorage.removeItem('items');
			// if(this.items && this.items.applyType=='4'){

			// }else{
			// 	  this.$router.push({ name: 'xal' }); localStorage.removeItem('items');
			// }

		},
		getReviewTable() {
			let params = {
				applyType: 4,
				applyId: this.id,
				expertUserId: this.expertUserId,
			};
			if (this.items && this.items.applyType == '4') {
				params.applyType = 4;
			} else {
				params.applyType = 1;
			}
			getAction("/lx/lxExpertItem/tablelist", params).then((res) => {
				if (res.code == 200) {
					// 回显已填写的专家评语与得分
					this.reviewData.remark = res.result.remark || "";
					let existScore = res.result.score;
					this.score = (existScore !== null && existScore !== '' && existScore !== '-')
						? Number(existScore) : null;
					// 回显评分指标及各指标已打分数
					let dataList = res.result.dataList || [];
					dataList.forEach((item) => {
						item.itemScore = (item.itemScore === null || item.itemScore === '' || item.itemScore === undefined)
							? null : Number(item.itemScore);
					});
					this.itemList = dataList;
				}
			});
		},
		gohrefs(url, title, urls) {
			// console.log(urls,"33333333");
			if (urls) {
				let filePath = url;
				let fileName = filePath.lastIndexOf(".");
				this.previewType = filePath.substring(
					fileName + 1,
					filePath.length
				);

				if (this.fileType === "doc" || this.fileType === "docx" || this.fileType === "ppt" || this.fileType === "pptx" || this.fileType === "xls" || this.fileType === "xlsx") {
					this.previewUrl = urls + "?time=" + Math.random();
				} else {
					this.previewUrl = urls + "?time=" + Math.random();
				}
				console.log(this.previewUrl, "55555");
			} else {
				let filePath = url;
				let fileName = filePath.lastIndexOf(".");
				this.previewType = filePath.substring(
					fileName + 1,
					filePath.length
				);
				let sj = filePath.substring(0, filePath.lastIndexOf("."));
				// 仅 office 文档使用后端转换的 pdf，其余文件（视频/图片等）保持原后缀
				if (["doc", "docx", "ppt", "pptx", "xls", "xlsx"].indexOf(this.previewType.toLowerCase()) > -1) {
					this.previewUrl = sj + ".pdf?time=" + Math.random() + "#zoom=120";
				} else {
					this.previewUrl = baseURL + filePath + "?time=" + Math.random() + "#zoom=120";
				}
			}
		},
		gohref(url, title, urls) {
			// console.log(urls,"4444");
			if (urls) {
				let filePath = url;
				let fileName = filePath.lastIndexOf(".");
				this.fileType = filePath.substring(
					fileName + 1,
					filePath.length
				);
				if (this.fileType === "doc" || this.fileType === "docx" || this.fileType === "ppt" || this.fileType === "pptx" || this.fileType === "xls" || this.fileType === "xlsx") {
					this.fileUrl = urls + "?time=" + Math.random();
				} else {
					this.fileUrl = urls + "?time=" + Math.random();
				}
			} else {
				let filePath = url;
				let fileName = filePath.lastIndexOf(".");
				this.fileType = filePath.substring(
					fileName + 1,
					filePath.length
				);
				let sj = filePath.substring(0, filePath.lastIndexOf("."));
				// 仅 office 文档使用后端转换的 pdf，其余文件（视频/图片等）保持原后缀
				if (["doc", "docx", "ppt", "pptx", "xls", "xlsx"].indexOf(this.fileType.toLowerCase()) > -1) {
					this.fileUrl = sj + ".pdf?time=" + Math.random();
				} else {
					this.fileUrl = baseURL + filePath + "?time=" + Math.random();
				}
			}

			this.title = title;
			this.isshow = true;
		},
		// 获取评审时间
		getexpertDateView() {
			expertDateView().then((res) => {
				if (res.code == 200) {
					this.reviewEndTimestamp = res.result.endTime;
				}
			});
		},
		closePreview() {
			this.isshow = false;
			this.title = '';
			this.fileType = '';
			this.fileUrl = '';
		},

	}
}
</script>
<style scoped lang="scss">
@import '@/assets/style/mixin.scss';

.content {
	width: 100%;
	min-height: 100vh;
	position: relative;
	/*.header-box {
			height: 172px;
			text-align: center;
			font-size: 47px;
			color: #fff;
			line-height: 172px;
			text-shadow: 2px 3px rgba(0, 0, 0, 0.5);
			background: url(/img/header-bg-al.4be82833.jpg);
			background-size: 100% 100%;
		}*/
}

.msg-box {
	width: 100%;
	height: 400px;

	img {
		display: block;
		margin: 20px auto;
	}

	.tip {
		color: #000;
		font-size: 16px;
		line-height: 40px;
		text-align: center;
	}
}

.back {
	width: 30px;
	height: 30px;
	position: absolute;
	top: 5px;
	right: 10px;
}

.videowrap {
	width: 85%;
	height: 600px;
	margin: 20px auto;
}

.contentsj {
	h4 {
		/*font-weight:bold;*/
		line-height: 40px;
		margin: 0px;
		font-size: 18px;
	}

	.img-preview {
		width: auto;
		height: auto;
		max-width: 100%;
		max-height: 100%;
		position: absolute;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}

	.img-preview-box {
		position: relative;
		max-height: 718px;
		overflow: hidden;
		width: 100%;
		height: 500px;
		/*background: #000;*/
	}
}

.headerbt {
	height: 40px;
	text-align: center;
	font-size: 24px;
	line-height: 40px;
	position: relative;
}

.preview-pop-box {
	width: 100vw;
	height: 100vh;
	position: fixed;
	z-index: 999;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.5);

	.preview-box {
		margin: 50px auto;
		width: 1177px;
		height: 90%;
	}

	.preview-box-fullscreen {
		width: 100vw;
		height: 100vh;
	}
}

* {
	font-size: 18px;
}

.img-box-2 {
	width: 19px;
	height: 19px;
	margin-right: 10px;
}

.bg-box {
	@include themeify {
		background: themed(content-bg) no-repeat bottom center, #f8f9ff;
		background-size: 100% auto;
	}
}

.line {
	height: 20px;
}

.pdf-wrap {
	width: 1290px;
	height: 1170px;
	margin: 0px auto;
}

/*.pdf-wrap{
		width:90%;
		height:800px;
		margin:0px auto;
	}*/
.flieList {
	width: 100%;
	min-height: 30px;
	display: flex;
	justify-content: flex-start;
	align-items: center;

	.listitem {
		font-size: 14px;
		margin-right: 20px;
		color: #9A0B00;
		;
		padding: 0px 10px;
		cursor: pointer;
	}

	.listitem:hover {}
}

.content-box {
	/*width: 1350px;
		min-height: 100vh;
		position: relative;
		margin: 0px auto;*/
	padding: 19px 30px;
	box-sizing: border-box;
	background-color: #fff;
}

.headerScore {
	font-size: 24px;
	font-weight: bold;
	line-height: 40px;
	text-align: center;
}

.review-content {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
	padding-bottom: 10px;

	/*margin-top:30px;*/
	.table {
		/deep/ .ant-table-thead>tr>th {
			font-size: 18px !important;
		}

		/deep/ .ant-table-tbody>tr>td {
			font-size: 18px;
			padding: 15px !important;
		}
	}
}

.target-score {
	margin-top: 10px;
	color: #6c6c6c;
	text-align: right;

	.number {
		font-size: 20px;
		color: #9A0B00;
	}

	.score {
		color: #9A0B00;
	}
}

.score-wrap {
	margin-top: 20px;
	text-align: center;
	font-size: 18px;
	color: #000;

	.score-label {
		font-weight: bold;
	}

	.score-input {
		width: 200px;
		margin: 0 10px;

		/deep/ input {
			font-size: 18px;
			text-align: center;
		}
	}

	.score-unit {
		color: #9A0B00;
	}
}

.expertReviews-title {
	font-size: 18px;
	color: #000;
}

.expertReviews-title:before {
	display: inline-block;
	width: 6px;
	height: 22px;
	background: #9A0B00;
	border-radius: 5px;
	content: "";
	/**
			    这个指为正的话 小方块就往上， 为负的话，小方块就往下
			    */
	vertical-align: middle;
	margin-right: 6px;
}

.remark-input {
	margin-top: 20px;
	resize: none;
}

.submit {
	width: 263px;
	height: 41px;
	background: #9A0B00;
	border-radius: 8px;
	line-height: 41px;
	text-align: center;
	margin: 0 auto;
	color: #ffffff;
	margin-top: 30px;
	cursor: pointer;
}
</style>